import React, {memo, useEffect} from 'react';
import './index.scss';
import {useHistory} from "react-router-dom";
import {setScreenSaverStatusAction} from "../../store/control/actions";
import {useDispatch} from "react-redux";
import {useRPC} from "../../hooks/rpc";
import {onClickHandler} from "../../utils/onclick";

let timerWithDigitalClock;

function setDateTime() {
    let d = new Date();
    document.getElementById("time").innerHTML = d.toLocaleTimeString('tr-TR', {
        hour: "2-digit",
        minute: "2-digit",
    });
    document.getElementById("date").innerHTML = d.toLocaleDateString('tr-TR', {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
    });
}


export const DigitalClock = memo(function DigitalClock() {
    const history = useHistory();
    const dispatch = useDispatch();
    const [rpc] = useRPC();
    const information = [
        "",
        "",
        "",
        "",
    ]
    useEffect(
        () => {
            setDateTime()
            timerWithDigitalClock = setInterval(() => {
                setDateTime()
            }, 5000);
        },
        [],
    );
    const hideDigital = () => {
        clearInterval(timerWithDigitalClock)
        dispatch(setScreenSaverStatusAction(''))
        history.push('/')
        rpc.touchEvent().then();
    }

    return (
        <div className="container-clock"  {...onClickHandler(hideDigital)}>
            <div id="div1">
                <p id="time"/>
                <p id="date"/>
                <div id="text">

                </div>
            </div>
        </div>

    );
});
